const formatDataAttributes = (data: Record<string, string> | undefined) =>
	data && Object.fromEntries(Object.entries(data).map(([name, value]) => ['data-' + name, value]));

export default formatDataAttributes;
